import makeTable from "./makeTable";

const allIds = [
	"platformBrand",
	"legalEntityName",
	"legalEntityIdno",
	"executorFullName",
	"executorTaxId",
	"registrationNumbers",
	"fleetName",
	"fleetIdno",
	"accessDocument",
	"accessValidity",
	"orderCount",
	"amount",
	"period",
] as const;

type Id = (typeof allIds)[number];

function every<T>(value: T): Record<Id, T> {
	return Object.fromEntries(allIds.map((id) => [id, value])) as Record<Id, T>;
}

/** Отчёт ANTA (Anexa nr.1): колонки в порядке регуляторной формы. */
const executorOrdersReport = makeTable({
	allIds: [...allIds],
	i18tPath: (id) =>
		`mainPage.reports.details.executorOrdersReport.columns.${id}`,
	defaultIds: [...allIds],
	initialSortMethod: {
		column: "executorFullName",
		type: "asc",
	},
	initialWidths: {
		platformBrand: 130,
		legalEntityName: 220,
		legalEntityIdno: 140,
		executorFullName: 180,
		executorTaxId: 140,
		registrationNumbers: 150,
		fleetName: 180,
		fleetIdno: 140,
		accessDocument: 140,
		accessValidity: 140,
		orderCount: 110,
		amount: 130,
		period: 190,
	},
	initialResizable: every(true),
	initialSortable: every(true),
});

export default executorOrdersReport;
